import type { ReactNode } from "react";

type EmptyStateProps = {
  iconClass: string;
  title: ReactNode;
  hint?: ReactNode;
  className?: string;
};

export default function EmptyState({
  iconClass,
  title,
  hint,
  className,
}: EmptyStateProps) {
  return (
    <div
      className={
        className ??
        "col-span-full flex flex-col items-center justify-center py-16 text-gray-400"
      }
    >
      <i className={`${iconClass} text-5xl mb-3`}></i>
      <p className="text-sm">{title}</p>
      {hint && <p className="text-xs mt-1">{hint}</p>}
    </div>
  );
}
